import { render, staticRenderFns } from "./AndonStockDashboard.vue?vue&type=template&id=80752ece&scoped=true&"
import script from "./AndonStockDashboard.vue?vue&type=script&lang=js&"
export * from "./AndonStockDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AndonStockDashboard.vue?vue&type=style&index=0&id=80752ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80752ece",
  null
  
)

export default component.exports